import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tagName", "aria-level"];
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { Heading } from '../Heading/Heading';
import { H7Provider } from './H7Provider';
import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const H7 = _ref => {
  let {
      tagName = 'h2',
      'aria-level': ariaLevel = 2
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const headingStyleOverrides = {
    fontSize: theme.typography['heading-50'].fontSize,
    fontFamily: theme.typography['heading-50'].fontFamily,
    fontWeight: theme.typography['heading-50'].fontWeight
  };
  return /*#__PURE__*/_jsx(H7Provider, {
    headingStyleOverrides: headingStyleOverrides,
    children: /*#__PURE__*/_jsx(Heading, Object.assign({
      tagName: tagName,
      "aria-level": ariaLevel
    }, restProps, {
      [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'H7'
    }))
  });
};
H7.displayName = 'H7';